














import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Player from './Player.vue'
import bus from './bus'
import { getStyleProperty, getSideMenuWidth } from '@/utils/util'

@Component({
	components: {
		Player,
	},
})
export default class CustomAudioPlayer extends Vue {
	private currentRecord: any = {}
	private show = false

	private closeAudio() {
		bus.$emit('close')
	}

	private setPlayerPos() {
		// 设置播放组件在右侧页面区域（对应左侧菜单栏）水平居中
		this.$nextTick(() => {
			let playerEl: any = this.$refs.audioWrapper
			if (playerEl) {
				let width = parseInt(getSideMenuWidth() || 0)
				let rightContentWidth = parseInt(
					getStyleProperty(
						document.querySelector('.ant-layout-content'),
						'width'
					) || 0
				)
				playerEl.style.left = `${width + rightContentWidth / 2}px`
			}
		})
	}

	private activated() {
		this.setPlayerPos()
		window.addEventListener('resize', this.setPlayerPos)
	}

	private created() {
		this.setPlayerPos()
		window.addEventListener('resize', this.setPlayerPos)

		bus.$on('play', (currentRecord: any) => {
			this.show = true
			this.currentRecord = currentRecord
		})
		bus.$on('close', () => {
			this.show = false
			this.currentRecord = {}
			bus.$emit('clear')
		})
	}

	private deactivated() {
		window.removeEventListener('resize', this.setPlayerPos)
	}

	private beforeDestroy() {
		window.removeEventListener('resize', this.setPlayerPos)
	}
}
